export default __webpack_public_path__ + "static/media/AdvertisingProfile.792ce857.svg";